import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import VaultQuestionsListLayer from "../../components/VaultQuestions/VaultQuestionsListLayer";


const VaultQuestionsList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Vault Questions" />

        <VaultQuestionsListLayer/>

      </MasterLayout>

    </>
  );
};

export default VaultQuestionsList; 
